<template>
  <div class="notification-card p-2">
    <div class="notification-card__heading font-weight-bold pb-2">
      進路活動記録
    </div>
    <div
      class="notification-card__content"
      @click="onClickActivePart">
      <div class="d-flex align-items-center">
        <User :user="notification.pathActivityComment.createdBy">
          <p class="comment__date">
            {{ notification.pathActivityComment.createdAt | prettyDateTime }}
          </p>
        </User>
      </div>
      <div>
        <div class="notification-card__detail">
          {{ notification.pathActivityComment.detail }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/parts/User.vue'

export default {
  components: {
    User,
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
      isProtecting: false
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
    onCheckRead() {
      this.checked = !this.checked
      this.$emit('check-read', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
.notification-card {
  &__heading {
    font-size: $fs-nm;
    font-weight: bold;
  }
  &__content {
    padding: 8px;
    background-color: $grey15;
  }
  &__detail {
    padding: 8px;
  }
}

.comment__date {
  font-size: $fs-m;
}
</style>